import React from "react";
import { Table, Tag, Tooltip, Button } from "antd";
import moment from "moment";

import { toBRL } from "~/components/UI/InputCurrency";
import { getDefaultPaginationConfig } from "~/utils/get-default-pagination-config";
import { STORAGE } from "~/constants/storage.constants";

var Column = Table.Column;

var TableList = function(props) {
    var data = props.data;
    var isLoading = props.isLoading;
    var categories = props.categories;
    var onEdit = props.onEdit;
    var onDelete = props.onDelete;
    var onMarkAsPaid = props.onMarkAsPaid;

    var renderStatus = function(status, record) {
        var isOverdue = status === 'pending' && moment(record.due_at).isBefore(moment(), 'day');

        if (status === 'paid') {
            return <Tag color="green" style={{ margin: 0 }}>Pago</Tag>;
        }
        if (isOverdue) {
            return <Tag color="red" style={{ margin: 0 }}>Vencido</Tag>;
        }
        if (status === 'pending') {
            return <Tag color="orange" style={{ margin: 0 }}>Pendente</Tag>;
        }
        if (status === 'cancelled') {
            return <Tag color="default" style={{ margin: 0 }}>Cancelado</Tag>;
        }
        return <Tag style={{ margin: 0 }}>{status}</Tag>;
    };

    var renderCategory = function(categoryId) {
        if (!categoryId) return <span style={{ color: '#bfbfbf' }}>-</span>;

        var category = categories.find(function(c) {
            return c.id === categoryId;
        });

        if (category) {
            return <Tag color="blue" style={{ margin: 0 }}>{category.value}</Tag>;
        }
        return <span style={{ color: '#bfbfbf' }}>-</span>;
    };

    var renderAmount = function(value) {
        return (
            <span style={{ fontWeight: 600, whiteSpace: 'nowrap', color: '#f5222d' }}>
                {toBRL(value)}
            </span>
        );
    };

    var renderActions = function(text, record) {
        var isPaid = record.status === 'paid';

        return (
            <div style={{ display: 'flex', gap: 4 }}>
                {!isPaid && (
                    <Tooltip title="Marcar como Pago">
                        <Button
                            size="small"
                            icon="check"
                            style={{ color: '#52c41a', borderColor: '#52c41a' }}
                            onClick={function() { onMarkAsPaid(record); }}
                        />
                    </Tooltip>
                )}
                <Tooltip title="Editar">
                    <Button
                        size="small"
                        icon="edit"
                        onClick={function() { onEdit(record); }}
                    />
                </Tooltip>
                <Tooltip title="Excluir">
                    <Button
                        size="small"
                        icon="delete"
                        type="danger"
                        onClick={function() { onDelete(record); }}
                    />
                </Tooltip>
            </div>
        );
    };

    var statusFilters = [
        { text: 'Pendente', value: 'pending' },
        { text: 'Pago', value: 'paid' },
        { text: 'Cancelado', value: 'cancelled' },
    ];

    var categoryFilters = categories.map(function(cat) {
        return { text: cat.value, value: cat.id };
    });

    var scrollY = Math.max(400, window.innerHeight - 380);

    return (
        <Table
            loading={isLoading}
            rowKey="id"
            dataSource={data}
            pagination={getDefaultPaginationConfig({
                storageKey: STORAGE.defaultPageSize.contasPagar || 'contasPagar',
            })}
            bordered={true}
            scroll={{ y: scrollY }}
            size="middle"
        >
            <Column
                title="Descrição"
                dataIndex="description"
                key="description"
                ellipsis={{ showTitle: true }}
                render={function(val) {
                    return (
                        <Tooltip title={val} placement="topLeft">
                            <span>{val}</span>
                        </Tooltip>
                    );
                }}
            />
            <Column
                title="Categoria"
                dataIndex="category_id"
                key="category_id"
                width={150}
                render={renderCategory}
                filters={categoryFilters}
                onFilter={function(value, record) { return record.category_id === value; }}
            />
            <Column
                title="Vencimento"
                dataIndex="due_at"
                key="due_at"
                width={120}
                render={function(val) { return val ? moment(val).format("DD/MM/YYYY") : '-'; }}
                sorter={function(a, b) {
                    return moment(a.due_at).unix() - moment(b.due_at).unix();
                }}
                defaultSortOrder="ascend"
            />
            <Column
                title="Valor"
                dataIndex="amount"
                key="amount"
                width={120}
                align="right"
                render={renderAmount}
                sorter={function(a, b) { return a.amount - b.amount; }}
            />
            <Column
                title="Status"
                dataIndex="status"
                key="status"
                width={100}
                render={renderStatus}
                filters={statusFilters}
                onFilter={function(value, record) { return record.status === value; }}
            />
            <Column
                title="Pago em"
                dataIndex="paid_at"
                key="paid_at"
                width={110}
                render={function(val) { return val ? moment(val).format("DD/MM/YYYY") : '-'; }}
            />
            <Column
                title=""
                key="actions"
                width={120}
                align="center"
                render={renderActions}
            />
        </Table>
    );
};

export default TableList;
